var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swipe-c"},[_vm._t("default"),_c('div',{staticClass:"dots"},_vm._l((_vm.pageCount),function(i){return _c('i',{key:i,staticClass:"dot",class:_vm.showingPage == i ? 'active': ''})}),0)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }